// mock for window apps
// window.__APPS__ = {
//   header: { branch: "master", commit: "e23c1149", date: "2021-8-10" },
//   index: { branch: "master", commit: "e23c1149", date: "2021-8-5" },
// };


export function msgToShip(msg) {
  window.postMessage({ direction: "from-morpheus", message: msg }, "*");
}

function handleBrowserAddonToolCommand(msg) {
  if (
    msg.source == window &&
    msg.data.direction &&
    msg.data.direction == "from-ship"
  ) {
    const m = msg.data.message;
    if (m.command == "call") {
      if (window && window.features) {
        for (let f of window.features) {
          if (f.name == m.tool) {
            f.callback();
          }
        }
      }
    }
  }
}

export function registerTool(name, callback) {
  sendEntryToBrowserAddon({
    name,
    expire: 0,
    value: false,
    type: "tool",
    callback,
  });
  if (window) {
    window.addEventListener("message", handleBrowserAddonToolCommand);
  }
  return () => {
    window.removeEventListener("message", handleBrowserAddonToolCommand);
  };
}

export function sendEntryToBrowserAddon({
  name,
  expire,
  value = false,
  type = "feature",
  callback = null,
}) {
  if (window) {
    if (window.features == undefined) {
      window.features = {};
    }
    if (window.features) {
      let msgToShipNeeded = false;
      if (window.features[name] === undefined) {
        window.features[name] = { expire, on: false, callback };
        msgToShipNeeded = true;
      }
      if (window.features[name].on != value) {
        msgToShipNeeded = true;
      }
      window.features[name] = { expire, on: value, callback }; // по умолчанию - выключено, если никто не включал
      if (msgToShipNeeded) {
        msgToShip({ name, expire, value, type });
      }
    }
  }
}
